import {
  CreateAddressOnlinePayload,
  CreateUserOfflineAddressPayload,
  UpdateAddressOnlinePayload,
  UpdateUserOfflineAddressPayload,
} from '../../models/payload/address';
import { offlineRopoloRequest, ropoloRequest } from '../axios';
import { UpdateLatLongAddressPayload } from './type';

const getCustomerOfflineAddress = async (id: string, networkStatus: boolean) =>
  (
    await (networkStatus
      ? ropoloRequest.identityAddressOfflineDetail(id)
      : offlineRopoloRequest.identityAddressOfflineDetail(id))
  ).data;
const getCustomerOnlineAddress = async () => (await ropoloRequest.identityAddressList()).data;

const createCustomerOfflineAddress = async (command: CreateUserOfflineAddressPayload, networkStatus: boolean) =>
  (
    await (networkStatus
      ? ropoloRequest.identityAddressOfflineCreate(command)
      : offlineRopoloRequest.identityAddressOfflineCreate(command))
  ).data;

const createCustomerOnlineAddress = async (command: CreateAddressOnlinePayload) =>
  (await ropoloRequest.identityAddressCreate(command)).data;

const updateCustomerOfflineAddress = async (command: UpdateUserOfflineAddressPayload) =>
  (await ropoloRequest.identityAddressOfflineUpdate(command)).data;

const updateCustomerOnlineAddress = async (command: UpdateAddressOnlinePayload) =>
  (await ropoloRequest.identityAddressUpdate(command)).data;

const removeCustomerAddress = async (id: string) => (await ropoloRequest.identityAddressDelete(id)).data;

const updateAddressLatLongOfflineUpdate = async (command: UpdateLatLongAddressPayload) =>
  (await ropoloRequest.identityAddressOfflineLatLongUpdate(command)).data;

export {
  getCustomerOfflineAddress,
  getCustomerOnlineAddress,
  createCustomerOnlineAddress,
  createCustomerOfflineAddress,
  removeCustomerAddress,
  updateCustomerOfflineAddress,
  updateCustomerOnlineAddress,
  updateAddressLatLongOfflineUpdate,
};
